import apiClient from "../utils/apiClient";
export const elementoPorSeccion = async (idElemento) => {
  try {
    const response = await apiClient.get(
      `/web/elementoporseccion/${idElemento}`
    );
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
/**
 * Retrieves the list of promotions from the web activities endpoint.
 *
 * @returns {Promise<Array<Object>>} - A promise that resolves to an array of promotion objects.
 * @throws {Error} - Throws an error if the connection fails.
 */

export const getProductsBySection = async (section) => {
  try {
    const response = await apiClient.get(`/actividades_pp/${section}`);
    return response?.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

export const getDestinyPP = async () => {
  try {
    const response = await apiClient.get("/obtener_destinos_pp");
    return response?.data;
  } catch (error) {
    throw new Error("Error connection", error);
  }
};

/**
 * Fetches the hotel markup data from the system.
 *
 * @returns {Promise<Object>} - An object containing the hotel markup data.
 * @throws {Error} - Throws an error if the connection fails.
 */

export const getMarkup = async () => {
  try {
    const response = await apiClient.get(`/sys/markup/hoteleria`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
export const getCurrencyExchange = async () => {
  try {
    const response = await apiClient.get(`/conversionPesos`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

/**
 * Obtiene la lista de promociones.
 *
 * @returns {Promise<Array<Object>>} - Un arreglo de objetos con la lista de secciones.
 *
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getFiltersBySection = async () => {
  try {
    const response = await apiClient.get(`web/actividades/EXP`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
export const getPPbySection = async (section) => {
  try {
    const response = await apiClient.get(`actividades_pp/${section}`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

export const getAllDestinations = async (section) => {
  try {
    const response = await apiClient.get(
      `/carruseles/destinos/seccion/${section}`
    );
    return response?.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

export const getActivityPPById = async (id) => {
  try {
    const response = await apiClient.get(`/actividad_pp/${id}`);
    return response?.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

export const getActivityPPImagesById = async (id) => {
  try {
    const response = await apiClient.get(`/actividades_pp/${id}/imagenes`);
    return response?.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

export const getActivityPPItinerarioPreciosById = async (id) => {
  try {
    const response = await apiClient.get(
      `/actividades_pp/${id}/itinerario_precios`
    );
    return response?.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
